.leftPanel {
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 25px 38px;

  &.mobile {
    padding: 20px;
  }

  .skinny {
    :global .ant-skeleton-content {
      display: flex;
      justify-content: center;
    }

    :global .ant-skeleton-title {
      border-radius: 40px;
      height: 17px;
    }
  }

  .thick {
    :global .ant-skeleton-content {
      display: flex;
      justify-content: center;
    }

    :global .ant-skeleton-title {
      border-radius: 40px;
      height: 37px;
    }
  }

  .progressSkeleton {
    :global .ant-skeleton-title {
      width: 192px;
      margin: 0 0 34px 0;
    }
  }

  .headerSkeleton {
    :global .ant-skeleton-title {
      width: 338px;
      margin: 0 0 8px 0;
    }
  }

  .subHeaderSkeleton {
    :global .ant-skeleton-title {
      width: 192px;
      margin: 0 0 53px 0;
    }
  }

  .paragraph1 {
    :global .ant-skeleton-title {
      width: 481px;
      margin: 0 0 17px 0;
    }

    &.mobile {
      :global .ant-skeleton-title {
        width: 327px;
        margin: 0 0 17px 0;
      }
    }
  }

  .paragraph2 {
    :global .ant-skeleton-content {
      justify-content: left;
    }

    :global .ant-skeleton-title {
      width: 266px;
      margin: 0 0 44px 0;
    }

    &.mobile {
      :global .ant-skeleton-title {
        width: 202px;
        margin: 0 0 44px 0;
      }
    }
  }
}
